import React, { useState } from 'react';
import Icon from '@cloudscape-design/components/icon';
import { SparklesIcon } from '@amzn/wwasft-components/icons';
import { useTutorial } from './TutorialProvider';
import './tutorial-banner.scss';

/** Animation duration for exit transitions (ms) - matches CSS slideOut */
const EXIT_ANIMATION_MS = 300;

export interface TutorialBannerProps {
  /** Feature name to highlight with gradient */
  featureName?: string;
  /** Description text after feature name */
  description?: string;
  /** Button text */
  buttonText?: string;
}

export const TutorialBanner: React.FC<TutorialBannerProps> = ({
  featureName = 'FinSpace AI Assistant',
  description = 'is here — discover what\'s possible',
  buttonText = 'Take the tour',
}) => {
  const { isBannerVisible, dismissBanner, startTutorial, tutorials } = useTutorial();
  const [isExiting, setIsExiting] = useState(false);

  if (!isBannerVisible || tutorials.length === 0) return null;

  const handleStartTour = () => {
    setIsExiting(true);
    setTimeout(() => startTutorial(tutorials[0]), EXIT_ANIMATION_MS);
  };

  const handleDismiss = () => {
    setIsExiting(true);
    setTimeout(() => dismissBanner(), EXIT_ANIMATION_MS);
  };

  return (
    <div className={`tutorial-banner ${isExiting ? 'tutorial-banner--exit' : ''}`}>
      <div className="tutorial-banner__content">
        <div className="tutorial-banner__left">
          <div className="tutorial-banner__icon">
            <SparklesIcon size="md" twinkle />
          </div>
          <span className="tutorial-banner__text">
            <strong>New!</strong> <span className="tutorial-banner__highlight">{featureName}</span> {description}
          </span>
        </div>
        <div className="tutorial-banner__right">
          {/* Native button for custom gradient/shimmer styling - matches Ask AI button pattern */}
          <button 
            className="finspace-button finspace-button--primary finspace-button--small finspace-button--gradient ask-ai-button"
            onClick={handleStartTour}
            data-testid="tour-button"
          >
            <span className="ask-ai-button__shimmer" />
            {buttonText}
          </button>
          <button 
            className="tutorial-banner__close" 
            onClick={handleDismiss}
            aria-label="Dismiss"
          >
            <Icon name="close" size="small" />
          </button>
        </div>
      </div>
    </div>
  );
};
